// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-datetime {
  margin: 0 auto;
  background: #f8f9fb;
}

.date-content {
  width: 100%;
  float: none;
  z-index: 9;
}

.time-content {
  width: 100%;
  float: none;
}

.label-date {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}

.label-time {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}

.buttonPWA {
  display: none;
}

.buttonMobile {
  display: block;
}

@media (min-width: 960px) {
  .label-date {
    display: none;
  }
  .label-time {
    display: none;
  }
  .date-content {
    width: 50%;
    float: left;
  }
  .time-content {
    width: 50%;
    float: right;
  }
  .time-pwa {
    padding-top: 12%;
  }
  .buttonPWA {
    display: block;
  }
  .buttonMobile {
    display: none;
  }
}
.boxx-btn {
  text-transform: uppercase;
}

.custom-title {
  color: var(--ion-color-light) !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/custom-datetime-picker/custom-datetime-picker.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAGA;EACI;IACI,aAAA;EAAN;EAEE;IACI,aAAA;EAAN;EAGE;IACI,UAAA;IACA,WAAA;EADN;EAIE;IACI,UAAA;IACA,YAAA;EAFN;EAKE;IACI,gBAAA;EAHN;EAME;IACI,cAAA;EAJN;EAOE;IACI,aAAA;EALN;AACF;AAQA;EACI,yBAAA;AANJ;;AASA;EACI,wCAAA;AANJ","sourcesContent":["ion-datetime{\n    margin: 0 auto;\n    background: #f8f9fb;\n}\n\n.date-content{\n    width: 100%;\n    float: none;\n    z-index: 9;\n}\n\n.time-content{\n    width: 100%;\n    float: none;\n}\n\n.label-date{\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n}\n\n.label-time{\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n}\n\n.buttonPWA{\n    display: none;\n}\n\n.buttonMobile{\n    display: block;\n}\n\n//PWA\n@media (min-width: 960px) {\n    .label-date{\n        display: none;\n    }\n    .label-time{\n        display: none;\n    }\n\n    .date-content{\n        width: 50%;\n        float: left;\n    }\n    \n    .time-content{\n        width: 50%;\n        float: right;\n    }\n\n    .time-pwa{\n        padding-top: 12%;\n    }\n\n    .buttonPWA{\n        display: block;\n    }\n\n    .buttonMobile{\n        display: none;\n    }\n}\n\n.boxx-btn{\n    text-transform: uppercase;\n}\n\n.custom-title{\n    color: var(--ion-color-light) !important;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
